<template>
  <input
    :type="type"
    :class="className"
    :placeholder="placeholder"
    :value="value"
    @input="handleInput"
    class="input_form"
  />
</template>

<script>
export default {
  name: "InputCustom",
  props: ["type", "className", "placeholder", "value"],
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
};
</script>

<style scoped lang="scss">
.valid {
  border-color: green;
}
.custon_input{
  padding: 0 20px;
  outline: transparent solid 2px;
}
.custon_input:focus-visible{
  z-index: 1;
  border-color: #3056d3;
  box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
}
.custon_input.error {
  color: #f93154 !important;
  border: 1px solid currentColor;
  background: #eec8c8 !important;

  animation: shake 0.72s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>
